(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('investmentAnalysis', investmentAnalysis);


    function investmentAnalysis() {
        var directive = {
            templateUrl: '/app/common/investment-analysis.html',
            restrict: 'EA',
            scope: {
                property: '=',        // main property object (InvestmentAnalysis contains)
                showContainer: '=?',  // show/hide container style (optional)
                loading: '=?'         // Loading state (optional)
            },
            controller: ['$scope', InvestmentAnalysisController]
        };
        return directive;

        function InvestmentAnalysisController($scope) {
            // Math.abs helper
            $scope.abs = Math.abs;

            // Default showContainer to true if not provided
            if ($scope.showContainer === undefined) {
                $scope.showContainer = true;
            }
        }
    }
})();
